import styled from "styled-components"
import { when, minWidth, maxWidth } from "utils"

export const ProductDescription = styled.div`
  * {
    line-height: 1.35;
  }
`

export const ProductHeader = styled.div`
  display: none;

  ${when("enabled")`
    display: block;
  `}

  h2 {
    margin-bottom: 2.6rem;
    font-size: 3.4rem;
    color: #767676;
    ${props =>
      props.theme.component.isDarkBackground &&
      `
      color: ${props.theme.component.text};
    `}

    p {
      margin: 0;
    }

    span,
    em {
      color: ${props => props.theme.component.highlight};
      font-style: inherit;
    }
  }
`

export const ProductTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.1rem;
  border-bottom: #d0d0d0 1px solid;
  color: ${props => props.theme.component.text};

  ${maxWidth.mobile`
    flex-wrap: wrap;
    margin-top: 0.6rem;
  `}

  ${minWidth.hamburgerLarge`
    flex-wrap: wrap;
    margin-top: 0.6rem;
  `}

  ${minWidth.desktopL`
    flex-wrap: nowrap;
  `}

  h3 {
    font-size: 3rem;
  }
`

export const ProductRatingWrapper = styled.div`
  display: flex;
`

export const ProductIngredients = styled.div`
  margin-top: 0.9rem;
  color: ${props => props.theme.component.text};
  font-size: 1.8rem;

  p {
    color: ${props => props.theme.component.text} !important;
    font-size: 1.8rem !important;
    margin: 0;
  }
`

export const ProductInfo = styled.div`
  margin-top: 1.8rem;
  margin-bottom: 3rem;
  font-size: 1.8rem;
  color: ${props => props.theme.component.text};

  ul {
    margin: 1.7rem 0 0 1.6rem;
    padding-left: 0;

    li {
      list-style-type: disc;
      margin-bottom: 0.5rem;
    }
  }
`
